/**
 * DateRole - Role para conversão e manipulação de datas
 *
 * ComplexRole com 3 variantes:
 * - iso: string ISO 8601 ("2024-12-05T19:30:00.000Z")
 * - timestamp: number em milissegundos (1733425800000)
 * - epoch: number em segundos (1733425800)
 *
 * @example
 * const date = new DateRole();
 * date.convert('iso', 'epoch', '2024-12-05T19:30:00.000Z')  // 1733425800
 * date.convert('epoch', 'iso', 1733425800)                  // '2024-12-05T19:30:00.000Z'
 * date.cast('iso', '2024-12-05')                            // '2024-12-05T00:00:00.000Z'
 * date.format('iso', '2024-12-05T19:30:00.000Z', { dateStyle: 'full', locale: 'pt-BR' })
 */

import { ComplexRole } from "../../contracts";
import type { IVariant } from "../../contracts";
import type { DateTimestamp, DateFormatOptions } from "./types";
import { IsoVariant, TimestampVariant, EpochVariant } from "./variants";

// =============================================================================
// DATE ROLE CLASS
// =============================================================================

export class DateRole extends ComplexRole<DateTimestamp> {
  readonly name = "date";
  readonly base = "timestamp";

  protected createVariants(): Record<string, IVariant<unknown, DateTimestamp>> {
    return {
      iso: new IsoVariant(),
      timestamp: new TimestampVariant(),
      epoch: new EpochVariant(),
    };
  }

  /**
   * Override format to accept DateFormatOptions
   */
  format(variant: string, value: unknown, options?: DateFormatOptions): string {
    return super.format(variant, value, options);
  }
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da DateRole */
export const dateRole = new DateRole();
